import './App.css';
import {Route, Routes} from "react-router-dom";
import Header from "./components/mainPage/header/header";
import SignIn from "./components/mainPage/signIn/signIn";
import UserList from "./components/mainPage/userList/userList";
import UserDetails from "./components/mainPage/userDetails/userDetails";
import React from "react";
import MainPage from "./components/mainPage/mainPage";

function App() {
  return (
    <div className="App">
      <Header />

      <Routes>
        <Route  path="/" element={<MainPage/>}>
        </Route>
        <Route  path="/signIn" element={<SignIn/>}>
        </Route>
        <Route  path="/userList" element={<UserList/>}>
        </Route>
        <Route  path={`/userDetails/:userId`} element={<UserDetails/>}>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
